import React from "react";
import propTypes from "prop-types";
import classNames from "classnames";
import { DefaultPageContainer as PageContainer } from "@layout";
import { Hero, HistoryAbout, ValuesAbout, CareersAbout, TeamAbout } from "@organisms";
import { FooterContact, CbColoredCopy } from "@molecules";

const AboutPage = ({ data }) => {
  const {
    hero,
    liveForThis,
    history,
    team,
    acrisure,
    ourValues,
    careers,
    meta,
  } = data;

  return (
    <PageContainer meta={meta}>
      <Hero {...hero} bleed />
      <CbColoredCopy
        {...liveForThis}
        backgroundColor="darkBlue"
        labelColor="yellow"
        headingColor="cream"
      />
      <div id="team">
        <TeamAbout {...team} />
      </div>
      <div id="our-history">
        <HistoryAbout {...history} />
      </div>
      <div id="acrisure-subsidiary">
        <CbColoredCopy
          {...acrisure}
          backgroundColor="darkBlue"
          labelColor="yellow"
          headingColor="teal"
        />
      </div>
      <div id="our-values">
        <ValuesAbout {...ourValues} />
      </div>
      <CareersAbout {...careers} />
      <FooterContact />
    </PageContainer>
  );
};

AboutPage.defaultProps = {};

AboutPage.propTypes = {};

export default AboutPage;
